import { StatusPill } from '../StatusPills';

/**
 * Audit-log severity on the four status tones. Critical is the breach tone
 * (and is also emailed to every admin); warning is "needs you".
 */
export const SEVERITY_TONES = {
  info: { tone: 'neutral', label: 'Info' },
  notice: { tone: 'held', label: 'Notice' },
  warning: { tone: 'needs', label: 'Warning' },
  critical: { tone: 'breach', label: 'Critical' },
};

/** Row background for a severity — only the two that need attention get one. */
export const severityRowClass = (severity) =>
  severity === 'critical' ? 'bg-breach-wash' : severity === 'warning' ? 'bg-amber-wash' : '';

const SeverityPill = ({ severity, size = 'sm' }) => {
  const entry = SEVERITY_TONES[severity] || SEVERITY_TONES.info;
  return (
    <StatusPill tone={entry.tone} size={size} testId={`severity-${severity || 'info'}`}>
      {entry.label}
    </StatusPill>
  );
};

export default SeverityPill;
